import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  CreditCard as SubscriptionIcon,
  CreditCard,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SubscriptionPromptDialog = ({ open, gatewayName, onClose }) => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
        },
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <CreditCard sx={{ fontSize: 64, opacity: 0.9 }} />
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
          Unlock Your Gateway
        </Typography>

        <Typography variant="h6" sx={{ mb: 3, opacity: 0.95, fontWeight: 400 }}>
          {gatewayName || 'This gateway'} is ready to connect!
        </Typography>

        <Box sx={{
          bgcolor: 'rgba(255, 255, 255, 0.15)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          backdropFilter: 'blur(10px)',
        }}
        >
          <Typography variant="body1" sx={{ mb: 2, opacity: 0.9 }}>
            To access your gateway and start monitoring your property, you'll need an active subscription.
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
              $15
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.8 }}>
              / month per gateway
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Cancel anytime • 30-day trial included
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, opacity: 0.9 }}>
            ✓ Real-time alerts and monitoring
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, opacity: 0.9 }}>
            ✓ Secure remote access
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, opacity: 0.9 }}>
            ✓ Multi-device support
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            ✓ 24/7 support
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0, flexDirection: 'column', gap: 1.5 }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() => {
            onClose();
            navigate('/subscription/plans');
          }}
          sx={{
            bgcolor: 'white',
            color: '#667eea',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            py: 1.5,
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.9)',
            },
          }}
          startIcon={<SubscriptionIcon />}
        >
          Start 30-Day Trial
        </Button>

        <Button
          fullWidth
          onClick={onClose}
          sx={{
            color: 'white',
            opacity: 0.8,
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.1)',
              opacity: 1,
            },
          }}
        >
          Maybe Later
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionPromptDialog;
